import type { LabelSheetCount } from '@aeris/printing'

/**
 * A conta de folhas em português de balcão — F127.
 *
 * "12 etiquetas → 1 folha de 30 (sobram 18 espaços)". A sobra é o que decide
 * "imprimo agora ou junto mais", e por isso aparece; no rolo não há folha, e
 * falar em folha para quem tem bobina na impressora confunde.
 */
export const labelSheetSummary = (
  labels: number,
  count: LabelSheetCount
): string => {
  const etiquetas = `${String(labels)} etiqueta${labels === 1 ? '' : 's'}`
  if (count.isRoll) return `${etiquetas} no rolo`

  const folhas = `${String(count.sheets)} folha${count.sheets === 1 ? '' : 's'} de ${String(count.perSheet)}`
  const sobra =
    count.emptyOnLast === 0
      ? ''
      : ` (sobra${count.emptyOnLast === 1 ? '' : 'm'} ${String(count.emptyOnLast)} espaço${count.emptyOnLast === 1 ? '' : 's'} na última)`
  return `${etiquetas} → ${folhas}${sobra}`
}
